var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5656 24.8826L21.528 16.9149C21.4182 16.8478 21.2925 16.8111 21.1638 16.8087C21.0351 16.8063 20.9081 16.8382 20.7959 16.9012C20.6836 16.9641 20.5902 17.0558 20.5251 17.1669C20.4601 17.278 20.4258 17.4043 20.4258 17.533V33.4684C20.4258 33.5971 20.4601 33.7235 20.5251 33.8346C20.5902 33.9456 20.6836 34.0373 20.7959 34.1003C20.9081 34.1632 21.0351 34.1952 21.1638 34.1928C21.2925 34.1903 21.4182 34.1537 21.528 34.0866L34.5656 26.1189C34.6715 26.0542 34.759 25.9633 34.8197 25.8551C34.8804 25.7469 34.9123 25.6248 34.9123 25.5007C34.9123 25.3766 34.8804 25.2546 34.8197 25.1464C34.759 25.0381 34.6715 24.9473 34.5656 24.8826Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.9db78ec2.svg";
export { ForwardRef as ReactComponent };